export const normalizeExplanationImageId = (value) =>
  typeof value === "string" ? value.trim() : "";

export const normalizeExplanationImageUrl = (value) => {
  const raw = typeof value === "string" ? value.trim() : "";
  if (!raw) return "";

  try {
    const url = new URL(raw);
    return `${url.origin}${url.pathname}`;
  } catch (_error) {
    return raw;
  }
};

export const collectInlineExplanationImageUrls = (html) => {
  if (typeof html !== "string" || !html.trim()) return [];

  const urls = [];
  const imageSrcPattern =
    /<img\b[^>]*\bsrc\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/gi;
  let match = imageSrcPattern.exec(html);

  while (match) {
    const src = match[1] || match[2] || match[3] || "";
    const normalized = normalizeExplanationImageUrl(src);
    if (normalized) urls.push(normalized);
    match = imageSrcPattern.exec(html);
  }

  return [...new Set(urls)];
};

const getImageUrl = (imageId, allImgPaths = {}) =>
  allImgPaths?.[imageId] || allImgPaths?.[String(imageId)] || "";

const addImageKeys = ({ keys, imageId, imageUrl }) => {
  const normalizedId = normalizeExplanationImageId(imageId);
  const normalizedUrl = normalizeExplanationImageUrl(imageUrl);

  if (normalizedId) keys.add(`id:${normalizedId}`);
  if (normalizedUrl) keys.add(`url:${normalizedUrl}`);
};

export const filterDuplicateExplanationImages = ({
  imageIds = [],
  allImgPaths = {},
  excludeImageIds = [],
  excludeImageUrls = [],
} = {}) => {
  const excludedKeys = new Set();

  excludeImageIds.forEach((imageId) => {
    addImageKeys({
      keys: excludedKeys,
      imageId,
      imageUrl: getImageUrl(imageId, allImgPaths),
    });
  });

  excludeImageUrls.forEach((imageUrl) => {
    addImageKeys({ keys: excludedKeys, imageUrl });
  });

  const seenKeys = new Set();
  const visibleImages = [];

  imageIds.forEach((imageId) => {
    const normalizedId = normalizeExplanationImageId(imageId);
    if (!normalizedId) return;

    const candidateKeys = new Set();
    addImageKeys({
      keys: candidateKeys,
      imageId: normalizedId,
      imageUrl: getImageUrl(normalizedId, allImgPaths),
    });

    if ([...candidateKeys].some((key) => excludedKeys.has(key))) return;
    if ([...candidateKeys].some((key) => seenKeys.has(key))) return;

    candidateKeys.forEach((key) => seenKeys.add(key));
    visibleImages.push(normalizedId);
  });

  return visibleImages;
};
